/* eslint-disable max-len */
import Cookies from 'react-cookies';
import merge from 'lodash/merge';
import queryString from 'query-string';
import CONSTANTS from 'src/constants/urls';
import AuthStorage from './auth-storage';
import handleFetchError from './handleFetchError';
import handleFormData from './handleFormData';
type Property = {
  url: string;
  options?: object;
  payload?: any;
  signature?: any;
};
const {
  API_CONTACT_US,
  API_ARTICLE_SLUG,
  API_EVENT,
  API_PARTNER
}: {
  API_CONTACT_US: any;
  API_ARTICLE_SLUG: any;
  API_EVENT: any;
  API_PARTNER: any;
} = CONSTANTS;
const getURI = (api_url: string, url: string, opts: any, payload: any) => {
  let uri = api_url + url;
  if (opts && opts.method === 'GET') {
    uri = queryString.stringifyUrl({
      url: uri,
      query: payload
    });
  }
  return uri;
};
const getPayload = (opts: any, payload: any) => {
  if (payload && Object.keys(payload).length > 0) {
    if (opts && opts.method === 'GET') {
      if (payload.filter) {
        payload.filter = JSON.stringify(payload.filter);
      }
    } else {
      handleFormData(opts, payload);
    }
  }
};
export const fetchApi = async ({
  url,
  options,
  payload = {} /* , dispatch = f => f */
}: Property, cb?: (...f: any) => void, api_url = API_CONTACT_US) => {
  try {
    const defaultOptions = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    };
    const opts: any = merge(defaultOptions, options);

    // set token
    if (await AuthStorage.value) {
      opts.headers.Authorization = `Bearer ${AuthStorage.value}`;
    }
    if (payload.filter) {
      payload.filter = JSON.stringify(payload.filter);
    }
    const uri = getURI(api_url, url, opts, payload);
    getPayload(opts, payload);
    const response = await fetch(uri, opts);
    if (response.ok && (response.status === 204 || response.statusText === 'No Content')) {
      if (cb) cb(null);
      return {};
    }
    const data = (await response.json()) || {};
    if (response.status !== 200) {
      throw data;
    }
    if (cb) cb(null, data);
    return data;
  } catch (err: any) {
    handleFetchError(err, cb);
  }
};
export const fetchApiEvent = async ({
  url,
  options,
  payload,
  signature = {} /* , dispatch = f => f */
}: Property, cb?: (...f: any) => void, api_url = API_EVENT) => {
  try {
    const defaultOptions = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-signature': signature
      }
    };
    const opts: any = merge(defaultOptions, options);

    // set token
    if (await AuthStorage.value) {
      opts.headers.Authorization = `Bearer ${AuthStorage.value}`;
    }
    if (payload.filter) {
      payload.filter = JSON.stringify(payload.filter);
    }
    const uri = getURI(api_url, url, opts, payload);
    getPayload(opts, payload);
    const response = await fetch(uri, opts);
    if (response.ok && (response.status === 204 || response.statusText === 'No Content')) {
      if (cb) cb(null);
      return {};
    }
    const data = (await response.json()) || {};
    if (response.status !== 200) {
      throw data;
    }
    if (cb) cb(null, data);
    return data;
  } catch (err: any) {
    handleFetchError(err, cb);
  }
};
export const fetchApiPublishing = async ({
  url,
  options,
  payload = {} /* , dispatch = f => f */
}: Property, cb?: (...f: any) => void, api_url = API_ARTICLE_SLUG) => {
  try {
    const defaultOptions = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    };
    const opts: any = merge(defaultOptions, options);

    // set token
    if (await AuthStorage.value) {
      opts.headers.Authorization = `Bearer ${AuthStorage.value}`;
    }
    if (payload.filter) {
      payload.filter = JSON.stringify(payload.filter);
    }
    const uri = getURI(api_url, url, opts, payload);
    getPayload(opts, payload);
    const response = await fetch(uri, opts);
    if (response.ok && (response.status === 204 || response.statusText === 'No Content')) {
      if (cb) cb(null);
      return {};
    }
    const data = (await response.json()) || {};
    if (response.status !== 200) {
      throw data;
    }
    if (cb) cb(null, data);
    return data;
  } catch (err: any) {
    handleFetchError(err, cb);
  }
};
export const fetchApiPartner = async ({
  url,
  options,
  payload = {} /* , dispatch = f => f */
}: Property, cb?: (...f: any) => void, api_url = API_PARTNER) => {
  try {
    const defaultOptions = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    };
    const opts: any = merge(defaultOptions, options);

    // set token
    // if (await AuthStorage.value) {
    // opts.headers.Authorization = `Bearer ${AuthStorage.value}`;
    // }

    const userData = Cookies.load('Token');
    const cleanedString = userData.replace(/"/g, '');
    opts.headers.Authorization = `Bearer ${cleanedString}`;
    if (payload.filter) {
      payload.filter = JSON.stringify(payload.filter);
    }
    const uri = getURI(api_url, url, opts, payload);
    getPayload(opts, payload);
    const response = await fetch(uri, opts);
    if (response.ok && (response.status === 204 || response.statusText === 'No Content')) {
      if (cb) cb(null);
      return {};
    }
    const data = (await response.json()) || {};
    if (response.status !== 200) {
      throw data;
    }
    if (cb) cb(null, data);
    return data;
  } catch (err: any) {
    handleFetchError(err, cb);
  }
};